import { appApi } from "@src/integrations/redux/app-api";
import { HTTP_METHODS } from "@src/utils/network-constants";
import { urlForRouteTimedShuttlesStops, urlForRouteTimedShuttles } from "../route-timed-shuttle-api-urls";
import type { PostRouteTimedShuttleStopsRequestDto } from "../route-timed-shuttle-dtos";

export interface PostRouteTimedShuttleStopsResponseDto {
  message: string;
  trackName: string;
  trackId: string;
}

export const routeTimedShuttleApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    postRouteTimedShuttleStops: builder.mutation<
      PostRouteTimedShuttleStopsResponseDto,
      { spaceId: string; body: PostRouteTimedShuttleStopsRequestDto }
    >({
      query: ({ spaceId, body }) => ({
        url: urlForRouteTimedShuttlesStops(spaceId),
        method: HTTP_METHODS.POST,
        body,
      }),
    }),
    getRouteTimedShuttleByTrackId: builder.query<
      PostRouteTimedShuttleStopsResponseDto & {
        stops: any[];
        route: [number, number][];
        distanceMeters?: number;
        durationSeconds?: number;
      },
      { spaceId: string; trackId: string }
    >({
      query: ({ spaceId, trackId }) => ({
        url: `${urlForRouteTimedShuttles(spaceId)}/${trackId}`,
        method: HTTP_METHODS.GET,
      }),
    }),
  }),
  overrideExisting: "throw",
});

export const {
  usePostRouteTimedShuttleStopsMutation,
  useGetRouteTimedShuttleByTrackIdQuery,
} = routeTimedShuttleApi;
